<template>
  <div>
    <vs-table :data="ehsList">
      <template slot="header">
        <h3>
          {{ title }}
        </h3>
      </template>
      <template slot="thead">
        <vs-th>
            <b>{{$t('client')}}</b>
        </vs-th>
        <vs-th>
            <b>{{$t('building_number')}}</b>
        </vs-th>
        <vs-th>
            <b>{{$t('title')}}</b>
        </vs-th>
        <vs-th>
          <b>{{$t('status')}} {{$t('and')}} {{$t('expiration')}}</b>
        </vs-th>
        <vs-th>
          <b>{{$t('comments')}}</b>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in ehsList" >
          <vs-td >
            {{data[indextr].client_short_name}}
          </vs-td>
          <vs-td >
            {{data[indextr].building_number}}
          </vs-td>
          <vs-td >
            <span class="material-icons sm blue-info" style="font-size:8px;">
              lens
            </span>
            {{data[indextr].category_name}}
          </vs-td>
          <vs-td  :class="['text-white']" :style="{background:data[indextr].status_color}">
            <span class="text-bold">{{data[indextr].status_name}}</span>
            {{data[indextr].date_expiration}}
          </vs-td>
          <vs-td :data="data[indextr].id">
            {{data[indextr].comment}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props:{
    ehsList:{
      default:[]
    },
    tableHeight:{
      default:''
    },
    title:{
      default:'title'
    }
  },
  data:()=>({
  })
}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

</style>